import ImageCard from './ImageCard';

const Projects = () => {
  const projects = [
    {
      title: 'Industrial Water Filter',
      description: 'Advanced filtration system for factories',
      imageSrc: '/images/project1.jpg',
    },
    {
      title: 'Commercial Water Plant',
      description: 'Sustainable solutions for commercial buildings',
      imageSrc: '/images/project2.jpg',
    },
    {
      title: 'Eco-Friendly System',
      description: 'Energy-efficient water treatment',
      imageSrc: '/images/project3.jpg',
    },
  ];

  return (
    <section id="projects" className="py-20 bg-gray-50">
      <h2 className="text-4xl font-bold text-center mb-12">Our Projects</h2>
      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {projects.map((proj, index) => (
          <ImageCard
            key={index}
            imageSrc={proj.imageSrc}
            title={proj.title}
            description={proj.description}
          />
        ))}
      </div>
    </section>
  );
};

export default Projects;
